const pageName = { singular: 'Tipe Bisnis', plural: 'Tipe Bisnis' }

export default [
  {
    path: '/business-type',
    name: 'business-type',
    component: () => import('@/views/pages/partner/business-type/Index.vue'),
    meta: {
      name: 'Tipe Bisnis',
      resource: 'Partner - Tipe Bisnis',
      action: 'manage',
    },
  },
]
